import React from 'react';
import './Testimonials.css';

import { Heading } from '../../../components';
import { testiContent } from '../../../constants';

import { FaQuoteLeft, FaStar } from 'react-icons/fa';

// Import Swiper core and required modules
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css'; 
import 'swiper/css/navigation';
import 'swiper/css/pagination';



const Testimonials = () => {

  return (
    <section className='testimonials'>

      {/* Section heading */}
      <Heading title={'our testimonials'} subTitle={`what our client's say`} />

      <div className='testimonial-slider'>

        <Swiper

          // Install Swiper modules
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={10} // Space between slides
          loop={true} // Infinite Looping
          autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-slide every 4 seconds
          navigation // Enables navigation buttons
          pagination={{ clickable: true }} // Enable pagination dots
        >
          {/* Map over the testiContent array to render each testimonial */}
          {testiContent.map((testimonial) => {

            // Destructure testimonial object
            const { id, image, content, name, title } = testimonial;

            return (
              <SwiperSlide className='testi-item' key={id}>

                <div className='content'>
                  <div className='quote-left'><FaQuoteLeft /></div> {/* Testimonial quote left icon */}
                  <p>"{content}"</p> {/* Testimonial */}
                  {/* Author Rating */}
                  <div className="rating">
                    <FaStar className="icon" />
                    <FaStar className="icon" />
                    <FaStar className="icon" />
                    <FaStar className="icon" />
                    <FaStar className="icon" />
                  </div>
                </div>

                <div className='intro'>
                  <img src={image} alt={name} /> {/* Author image */}
                  <h3>{name}</h3> {/* Author name */}
                  <h5>{title}</h5> {/* Author title */}
                </div>

              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}

export default Testimonials;